import { Link } from "@/lib/router-compat";
import { Zap, ArrowRight, Phone } from "lucide-react";

interface Props {
  title?: string;
  description?: string;
  buttonText?: string;
}

/**
 * Reusable insurance verification CTA block.
 * Designed to sit between main content and the FAQ section
 * on treatment program and condition pages.
 */
const InsuranceCTABlock = ({
  title = "Check If Your Insurance Covers This Program",
  description = "Most HMO, PPO, and EPO plans cover PHP and IOP. Find out in 60 seconds — free and completely confidential.",
  buttonText = "Verify Insurance Now",
}: Props) => (
  <section className="bg-white py-12 md:py-16">
    <div className="container max-w-4xl">
      <div
        className="rounded-xl text-center"
        style={{
          background: "#FAF4F0",
          borderTop: "3px solid #8B1A1A",
          padding: "32px",
        }}
      >
        <div className="flex justify-center mb-4">
          <div
            className="h-14 w-14 rounded-full flex items-center justify-center"
            style={{ background: "rgba(201,168,76,0.15)" }}
          >
            <Zap className="h-7 w-7" style={{ color: "#C9A84C" }} fill="#C9A84C" />
          </div>
        </div>
        <h2
          className="font-display font-bold mb-3"
          style={{ color: "#8B1A1A", fontSize: "clamp(22px, 3vw, 28px)", lineHeight: 1.2 }}
        >
          {title}
        </h2>
        <p
          className="mx-auto mb-6"
          style={{
            color: "#2C2C2C",
            fontSize: 16,
            lineHeight: 1.6,
            maxWidth: 560,
          }}
        >
          {description}
        </p>
        <Link
          to="/verify-insurance"
          aria-label={buttonText}
          className="inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-transform hover:scale-[1.02]"
          style={{
            background: "#8B1A1A",
            color: "#FAF4F0",
            padding: "14px 32px",
            fontSize: 16,
          }}
        >
          {buttonText} <ArrowRight className="h-4 w-4" />
        </Link>
        <div className="mt-4">
          <a
            href="tel:8562003127"
            className="inline-flex items-center gap-1.5 text-sm hover:underline"
            style={{ color: "#6B1414" }}
          >
            <Phone className="h-3.5 w-3.5" /> Or call 856-200-3127
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default InsuranceCTABlock;
